<template>
  <div>
    <div class="head">
      Airtag List
    </div>
    
    <div class="wrap-box">
      <div class="action d-flex justify-space-between align-center">
        <div>
          <button class="button cta small" @click="getList(false)">
            <i class="fas fa-redo fa-fw"></i> Refresh
          </button>
          <button class="button cta small" @click="showGenerateModal">
            <i class="fas fa-plus fa-fw"></i> Generate Codes
          </button>
          <button class="button cta small success" @click="getList(true)">
            Export
          </button>
        </div>
        <div>
          <button class="button cta small error" @click="confirm('void')">
            Void
          </button>
          <button class="button cta small success" @click="confirm('fulfill')">
            Fulfill
          </button>
        </div>
      </div>

      <div class="stats d-flex justify-space-between align-center">
        <div>
          <label>Total:</label>
          <span>{{ total }}</span>
        </div>
        <div>
          <label>Emailed:</label>
          <span>{{ emailed }}</span>
        </div>
        <div>
          <label>Redeem:</label>
          <span>{{ redeem }}</span>
        </div>
        <div>
          <label>Fulfilled:</label>
          <span>{{ fulfilled }}</span>
        </div>
        <div>
          <label>Voided:</label>
          <span>{{ voided }}</span>
        </div>
      </div>

      <table class="table-box" cellspacing="0">
        <thead>
          <th></th>
          <th>Code</th>
          <th>Name</th>
          <th>Phone</th>
          <th>Mailing Address</th>
          <th>RSVP</th>
          <th>Fulfill</th>
          <th></th>
        </thead>
        <tbody>
          <tr v-if="!list.length">
            <td colspan="8" class="empty">No record found.</td>
          </tr>
          <tr v-for="dat in list">
            <td class="check"><input type="checkbox" :value="dat.id" v-model="selected" /></td>
            <td>{{dat.code}}</td>
            <td>{{dat.name}}</td>
            <td>{{dat.phone}}</td>
            <td>{{dat.address}}</td>
            <td>
              <span v-if="!dat.rsvp.length">--</span>
              <span v-else>
                <a v-for="(rsvp, r) in dat.rsvp" :href="`#/reservation/${rsvp}`" target="_blank" :key="r" class="rsvp">{{rsvp}}</a>
              </span>
            </td>
            <td :class="{'fulfilled':dat.fulfill !== '--'}">{{dat.fulfill}}</td>
            <td>
              <span v-if="dat.voided" class="void">VOID</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <generate ref="generate" @refreshList="getList"></generate>
    <confirm ref="confirm" @proceed="proceed" :action="action"></confirm>
  </div>
</template>

<script>
import moment from 'moment'
import generate from './generate'
import confirm from './confirm'
import CsvExport from 'csvexport'

export default {
  name: 'admin-airtag',
  components: { generate, confirm },
  data () {
    return {
      list: [],
      selected: [],
      action: '',
      total: 0,
      emailed: 0,
      redeem: 0,
      fulfilled: 0,
      voided: 0,
    }
  },
  computed: {
    disabledDate () {
      if (this.today.format('MM') === '01') {
        return {
          to: new Date(
            this.today.subtract(1, 'months').format('YYYY'),
            this.today.format('MM'),
            this.today.format('DD')
          )
        }
      }

      return {
        to: new Date(
          this.today.format('YYYY'),
          this.today.subtract(1, 'months').format('MM'),
          this.today.format('DD')
        )
      }
    },
  },
  methods: {
    calendarFormat (date) { return moment(date).format('MM/DD/YYYY') },
    getList (exportCsv = false) {
      let self = this

      self.$store.commit('global/setLoaderData', {show: true, message: ''})
      self.$sdk.get('/promo/airtag/list', {
        token: self.$store.state.session.sessionToken
      }, r => {
        self.$store.commit('global/setLoaderData', {show: false, message: ''})
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          self.list = []
          return
        }

        let tmp = []
        let emailed = 0
        let redeem = 0
        let fulfilled = 0
        let voided = 0

        let tmpExport = []
        r.list.forEach(x => {
          if (x.emailUTC) emailed++
          if (x.redeemUTC) redeem++
          if (x.fulfillUTC) fulfilled++
          if (x.voided) voided++

          let addr = ''
          if (x.custAddress1) addr = `${x.custAddress1}, ${x.custCity}, ${x.custState}, ${x.custZip}`

          let rsvp = []
          if (x.rsvpId1) rsvp.push(x.rsvpId1)
          if (x.rsvpId2) rsvp.push(x.rsvpId2)
          tmp.push({
            id: x.id,
            code: x.code,
            name: x.custName,
            phone: x.custPhone,
            address: addr,
            rsvp: rsvp,
            fulfill: !x.fulfillUTC ? '--' : moment(x.fulfillUTC).format('MM/DD/YYYY hh:mmA'),
            voided: x.voided
          })

          if (exportCsv) {
            tmpExport.push({
              'Code': x.code,
              'Name': x.custName,
              'Phone': x.custPhone,
              'Mailing Address': addr,
              'RSVP': rsvp.join(', '),
              'Fulfill': !x.fulfillUTC ? '--' : moment(x.fulfillUTC).format('MM/DD/YYYY hh:mmA'),
              'Is Voided': x.voided ? 'Yes' : 'No',
            })
          }
        })
        self.list = tmp

        self.total = r.list.length
        self.emailed = emailed
        self.redeem = redeem
        self.fulfilled = fulfilled
        self.voided = voided

        if (exportCsv) {
          tmpExport.push({
            'Code': '',
            'Name': '',
            'Phone': '',
            'Mailing Address': '',
            'RSVP': '',
            'Fulfill': '',
            'Is Voided': '',
          })
          tmpExport.push({
            'Code': 'Total',
            'Name': r.list.length,
            'Phone': '',
            'Mailing Address': '',
            'RSVP': '',
            'Fulfill': '',
            'Is Voided': '',
          })
          tmpExport.push({
            'Code': 'Emailed',
            'Name': emailed,
            'Phone': '',
            'Mailing Address': '',
            'RSVP': '',
            'Fulfill': '',
            'Is Voided': '',
          })
          tmpExport.push({
            'Code': 'Redeem',
            'Name': redeem,
            'Phone': '',
            'Mailing Address': '',
            'RSVP': '',
            'Fulfill': '',
            'Is Voided': '',
          })
          tmpExport.push({
            'Code': 'Fulfilled',
            'Name': fulfilled,
            'Phone': '',
            'Mailing Address': '',
            'RSVP': '',
            'Fulfill': '',
            'Is Voided': '',
          })
          tmpExport.push({
            'Code': 'Voided',
            'Name': voided,
            'Phone': '',
            'Mailing Address': '',
            'RSVP': '',
            'Fulfill': '',
            'Is Voided': '',
          })
          const exporter = CsvExport.create({
            filename: 'airtag-report.csv',
            columns: [
              'Code', 'Name', 'Phone', 'Mailing Address', 
              'RSVP', 'Fulfill', 'Is Voided'
            ]
          })
          exporter.downloadCsv(tmpExport)
        }
      })
    },
    showGenerateModal () {
      if (this.$refs.generate) this.$refs.generate.showModal()
    },
    confirm (x) {
      if (!this.selected.length) {
        this.$store.commit('global/setAlertData', {
          show: true,
          message: 'No items selected.'
        })
        return
      }

      this.action = x
      if (this.$refs.confirm) this.$refs.confirm.showModal()
    },
    proceed () {
      if (this.action === 'void') this.void()
      if (this.action === 'fulfill') this.fulfill()
    },
    void () {
      let self = this

      if (!self.selected.length) {
        self.$store.commit('global/setLoaderData', {show: false, message: ''})
        self.getList()
        return
      }

      self.$store.commit('global/setLoaderData', {show: true, message: ''})
      self.$sdk.post('/promo/airtag/void', {
        token: self.$store.state.session.sessionToken,
        id: self.selected[0]
      }, r => {
        if (r.error) {
          self.$store.commit('global/setLoaderData', {show: false, message: ''})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          self.getList()
          return
        }

        self.selected.shift()
        self.void()
      })
    },
    fulfill () {
      let self = this

      if (!self.selected.length) {
        self.$store.commit('global/setLoaderData', {show: false, message: ''})
        self.getList()
        return
      }

      self.$store.commit('global/setLoaderData', {show: true, message: ''})
      self.$sdk.post('/promo/airtag/fulfill', {
        token: self.$store.state.session.sessionToken,
        id: self.selected[0]
      }, r => {
        if (r.error) {
          self.$store.commit('global/setLoaderData', {show: false, message: ''})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          self.getList()
          return
        }

        self.selected.shift()
        self.fulfill()
      })
    }
  },
  mounted () {
    this.getList()
  }
}
</script>

<style lang="scss" scoped>
.head{
  height: 50px;
  font-weight: 600;
  color: #fff;
  padding: 0 10px;
  width: calc(100% - 50px);
  margin-left: 50px;
  font-size: 21px;
  line-height: 50px;
  background: #333;
}
.wrap-box{
  width: 100%;
  max-width: 1100px;
  padding: 10px;
  margin: 0 auto;
}

.stats{
  background: #fafafa;
  border: 1px solid #ccc;
  margin-top: 30px;
  font-size: 14px;
  letter-spacing: .7px;
  border-radius: 2px;

  div{
    padding: 5px 10px;
  }
  span{
    font-weight: 600;
    display: inline-block;
  }
}

.table-box{
  margin-top: 10px;
  width: 100%;
  border: 1px solid #ccc;
  background: #fafafa;
  border-radius: 4px;
  overflow: hidden;

  th{
    border-bottom: 1px solid #ddd;
    padding: 5px;
    background: #333;
    color: #fff;
  }
  tr{
    text-align: center;

    &:hover td{
      background: #eaeaea!important;
    }
  }
  td{
    padding: 7px;
    font-size: 14px;
  }
  tr:nth-child(odd) td{
    background: #f3f3f3;
  }
  .empty{
    padding: 30px;
    font-weight: 600;
    font-size: 28px;
    color: #777;
  }
  .check{
    width: 50px;
  }
  input{
    margin: 0;
  }
  .rsvp{
    display: inline-block;
    margin: 2px 5px;
  }
  .fulfilled{
    color: #17bb2b;
    font-weight: 600;
    letter-spacing: .6px;
  }
  .void{
    letter-spacing: .7px;
    font-size: 13px;
    background: #333;
    color: #fff;
    padding: 2px 5px;
    border-radius: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Airtag/index.vue